import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectSubscriptionsListItems } from "../../../../../redux/subscriptions/selector";
import { subscriptions } from "../../../../../redux/subscriptions/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";


const ManagementSubscriptions = () => {
	const dispatch = useAppDispatch()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
    const subscriptionsItems = useSelector(selectSubscriptionsListItems)
    const navigate = useNavigate()
    const [
        columnDefs,
        setColumnDefs
      ] = useState({});
      const createColumnDefs: any = () => {
        setColumnDefs([
          {
            field: 'Sl',
            sortable: false,
            filter: false,
            isSortLabel: true,
            headerName: 'Sl',
            cellRenderer (params: any) {
              return parseInt(
                params.node.id,
                10
              ) + 1;
            },
          },
  
          { field: 'LicenseId', headerName: 'License Id',searchField: 'LicenseId', filter: true,
            filterType: 'text' },
          { field: 'OrganizationUnitId', headerName: 'OrganizationUnit',searchField: 'OrganizationUnitId', filter: true,
            filterType: 'text' },
          { field: 'NPSubscriptionName', headerName: 'NP Subscription Name',searchField: 'NPSubscriptionName', filter: false},
          { field: 'TotalNoOfDBaaSSubscriptions', headerName: 'Total No of Subscriptions',searchField: 'TotalNoOfDBaaSSubscriptions', 
            filter: false}, 
          { field: 'CreatedOnUtc', headerName: 'CreatedOn',isDateValueFormat: true, sortable: true  },
          { field: 'ModifiedOnUtc', headerName: 'ModifiedOn',isDateValueFormat: true, sortable: true },
        ]);
      }
      const fetchSubscriptions=()=>{
        dispatch(subscriptions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/platform-management/np-subscriptions/list`,entity:'subscriptions',jsonData:{
          "Context": {
            "Subscription": "ONE",
                                    "Domain": "ONE",
                                    "SubDomains": [],
                                    "Network": "Venture",
                                    "Application": "Venture",
                                    "Channel": "CSP"
          },
            "Records": [
              {
                "Id": 0
              }
            ],
           
          }
        
        }))
      }
     
	useEffect(() => {
        createColumnDefs()
        fetchSubscriptions()
	}, [pageData,pageSize])
   
  
  const handleReloadData = () => {
    fetchSubscriptions();
  }
  const additionButtons: any = [

    {
      svg:
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
        <title>Reload</title>
        <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      </svg>,
      callback: () => handleReloadData(),
    },
  ];
	return (
    <>
  
                {subscriptionsItems?.isLoading ?  <PageLoader />: 

<Table  
columnData={columnDefs} rowData={subscriptionsItems?.result?.items} setPageData={setPageData}
checkboxConfig={{
  allowMultiSelect: true,
  defaultSelectedIds: [],
  isDisabled: false,
  keyColumn: 'Name',
}}  headingName="NP Subscriptions"
setPageSize={setPageSize}paginationData={subscriptionsItems?.result?.pagination} additionButtons={additionButtons}/>

}
            
  </> 
	);
};

export default ManagementSubscriptions;


